"use strict";

var _interopRequireDefault = require("/root/.jenkins/workspace/web-ug-admin-dev/node_modules/@babel/runtime/helpers/interopRequireDefault.js");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
require("core-js/modules/web.dom.iterable");
var _typeof2 = _interopRequireDefault(require("/root/.jenkins/workspace/web-ug-admin-dev/node_modules/@babel/runtime-corejs2/helpers/typeof.js"));
var _objectSpread2 = _interopRequireDefault(require("/root/.jenkins/workspace/web-ug-admin-dev/node_modules/@babel/runtime-corejs2/helpers/objectSpread2.js"));
var _regenerator2 = _interopRequireDefault(require("/root/.jenkins/workspace/web-ug-admin-dev/node_modules/@babel/runtime-corejs2/helpers/regenerator.js"));
require("regenerator-runtime/runtime");
var _asyncToGenerator2 = _interopRequireDefault(require("/root/.jenkins/workspace/web-ug-admin-dev/node_modules/@babel/runtime-corejs2/helpers/asyncToGenerator.js"));
require("core-js/modules/es6.number.constructor");
var _dispositionl = require("@/api/dispositionl");
var _ossUpload = require("@/utils/ossUpload");
var _sortablejs = _interopRequireDefault(require("sortablejs"));
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var _default = exports.default = {
  name: 'HierarchicalAllocation',
  props: {
    appId: {
      type: Number,
      default: 0
    }
  },
  data: function data() {
    return {
      tableLoading: false,
      tableData: [],
      // 弹窗
      dialogVisible: false,
      TimeOptions: [{
        value: 30,
        label: '30天内'
      }, {
        value: 60,
        label: '60天内'
      }, {
        value: 90,
        label: '90天内'
      }, {
        value: 180,
        label: '不限'
      }],
      // 时间数组展示
      headStatus: [{
        value: 1,
        label: '禁用'
      }, {
        value: 0,
        label: '启用'
      }],
      // 状态
      dialogImageUrl: '',
      // url展示
      ruleForm: {
        name: '',
        // 等级名称
        icon: '',
        // 图片
        upgradeModel: '',
        // 条件模式
        subRate: '',
        termList: [{
          enable: 0,
          // 0-禁用 1：启用
          termItem: '邀请用户',
          // 条件名称
          timeRange: '30',
          // 升级周期
          requiredValue: '' // 条件值
        }, {
          enable: 0,
          // 0-禁用 1：启用
          termItem: '自购订单',
          // 条件名称
          timeRange: '30',
          // 升级周期
          requiredValue: '' // 条件值
        }, {
          enable: 0,
          // 0-禁用 1：启用
          termItem: '自购收货',
          // 条件名称
          timeRange: '30',
          // 升级周期
          requiredValue: '' // 条件值
        }, {
          enable: 0,
          // 0-禁用 1：启用
          termItem: '预估收益',
          // 条件名称
          timeRange: '30',
          // 升级周期
          requiredValue: '' // 条件值
        }, {
          enable: 0,
          // 0-禁用 1：启用
          termItem: '结算收益',
          // 条件名称
          timeRange: '30',
          // 升级周期
          requiredValue: '' // 条件值
        }],
        selfRate: '',
        // 自购分佣
        lateralModel: 0,
        // 平级奖励
        teamRate: '',
        // 团队分佣
        lateralRateList: [{
          order: 1,
          // 位置
          rate: 0 // 比例
        }, {
          order: 2,
          // 位置
          rate: 0 // 比例
        }, {
          order: 3,
          // 位置
          rate: 0 // 比例
        }],
        status: '' // 状态
      },
      rules: {
        name: [{
          validator: this.validateName,
          trigger: 'blur'
        }],
        icon: [{
          required: true,
          message: '请上传等级图标',
          trigger: 'blur'
        }]
      },
      // 删除弹窗
      delDialogVisible: false,
      unitData: {
        '邀请用户': '人',
        '自购订单': '笔',
        '自购收货': '笔',
        '预估收益': '元',
        '结算收益': '元'
      },
      addIsRenewal: 'add',
      // 操作类型（添加and编辑）
      // nameListData: [], // 过滤数组
      isExceed: false
    };
  },
  mounted: function mounted() {
    var _this = this;
    if (this.appId !== 0) {
      this.listClassSetApi();
    }
    var tbody = document.querySelector('.my_table_name .el-table__body-wrapper tbody');
    console.log('tbody', tbody);
    _sortablejs.default.create(tbody, {
      handle: '.handle',
      animation: 150,
      onEnd: function onEnd(_ref) {
        var newIndex = _ref.newIndex,
          oldIndex = _ref.oldIndex;
        console.log('id', _this.tableData[oldIndex].grade, newIndex);
        _this.moveClassSetApi(_this.tableData[oldIndex].grade, newIndex);
      }
    });
  },
  methods: {
    // 编辑
    onEditor: function onEditor(data) {
      this.addIsRenewal = 'renewal';
      this.getClassSetApi(data.grade);
      this.dialogVisible = true;
    },
    // 列表删除
    onDelete: function onDelete(data) {
      var _this2 = this;
      if (data.status === 0) {
        this.$confirm('当前等级在启用状态，不可删除！', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(function () {
          // this.$message({
          //   type: 'info',
          //   message: '已取消'
          // })
        }).catch(function () {
          _this2.$message({
            type: 'info',
            message: '已取消'
          });
        });
        return false;
      }
      this.$confirm('是否确认要删除该等级?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(function () {
        _this2.deleteClassSetApi(Number(data.grade));
      }).catch(function () {
        _this2.$message({
          type: 'info',
          message: '已取消'
        });
      });
    },
    // 提示判断
    validateName: function validateName(rule, value, callback) {
      if (!value) {
        return callback(new Error('等级名称不能为空'));
      }
      // if (this.addIsRenewal === 'add') {
      //   if (this.nameListData.includes(value)) {
      //     return callback(new Error('该等级名称已被创建'))
      //   }
      // }

      callback();
    },
    onAddAllocation: function onAddAllocation() {
      this.addIsRenewal = 'add';
      this.dialogVisible = true;
    },
    close: function close() {
      this.dialogVisible = false;
      this.resetForm();
    },
    delClose: function delClose() {},
    // 图片预览
    handleAvatarSuccess: function handleAvatarSuccess(res, file) {
      this.dialogImageUrl = URL.createObjectURL(file.raw);
      this.$refs.upload.clearFiles(); // 上传成功之后清除历史记录
    },
    // 图片上传
    onRequest: function () {
      var _onRequest = (0, _asyncToGenerator2.default)(/*#__PURE__*/(0, _regenerator2.default)().m(function _callee(_ref2) {
        var file, res;
        return (0, _regenerator2.default)().w(function (_context) {
          while (1) switch (_context.n) {
            case 0:
              file = _ref2.file;
              _context.n = 1;
              return (0, _ossUpload.uploadOSS)(file);
            case 1:
              res = _context.v;
              this.ruleForm.icon = res;
              console.log(res);
            case 2:
              return _context.a(2);
          }
        }, _callee, this);
      }));
      function onRequest(_x) {
        return _onRequest.apply(this, arguments);
      }
      return onRequest;
    }(),
    // 表单提交
    submitForm: function submitForm(formName) {
      var _this3 = this;
      if (Number(this.ruleForm.selfRate) > 100) {
        this.isExceed = true;
        return false;
      } else {
        this.isExceed = false;
      }
      this.$refs[formName].validate(function (valid) {
        console.log('valid', valid);
        if (valid) {
          if (_this3.addIsRenewal === 'add') {
            _this3.saveClassSetApi();
          } else {
            _this3.updateClassSetApi();
          }
        } else {
          console.log('error submit!!');
          return false;
        }
      });
    },
    // 表单重置
    resetForm: function resetForm() {
      var formName = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'ruleForm';
      this.$refs[formName].resetFields();
      this.ruleForm = {
        name: '',
        // 等级名称
        icon: '',
        // 图片
        upgradeModel: '',
        // 条件模式
        termList: [{
          enable: 0,
          // 0-禁用 1：启用
          termItem: '邀请用户',
          // 条件名称
          timeRange: '30',
          // 升级周期
          requiredValue: '' // 条件值
        }, {
          enable: 0,
          // 0-禁用 1：启用
          termItem: '自购订单',
          // 条件名称
          timeRange: '30',
          // 升级周期
          requiredValue: '' // 条件值
        }, {
          enable: 0,
          // 0-禁用 1：启用
          termItem: '自购收货',
          // 条件名称
          timeRange: '30',
          // 升级周期
          requiredValue: '' // 条件值
        }, {
          enable: 0,
          // 0-禁用 1：启用
          termItem: '预估收益',
          // 条件名称
          timeRange: '30',
          // 升级周期
          requiredValue: '' // 条件值
        }, {
          enable: 0,
          // 0-禁用 1：启用
          termItem: '结算收益',
          // 条件名称
          timeRange: '30',
          // 升级周期
          requiredValue: '' // 条件值
        }],
        selfRate: '',
        // 自购分佣
        subRate: '',
        lateralModel: 0,
        // 平级奖励
        teamRate: '',
        // 团队分佣
        lateralRateList: [{
          order: 1,
          // 位置
          rate: 0 // 比例
        }, {
          order: 2,
          // 位置
          rate: 0 // 比例
        }, {
          order: 3,
          // 位置
          rate: 0 // 比例
        }],
        status: '' // 状态
      };
      this.isExceed = false;
    },
    // 列表
    listClassSetApi: function () {
      var _listClassSetApi2 = (0, _asyncToGenerator2.default)(/*#__PURE__*/(0, _regenerator2.default)().m(function _callee2() {
        var params, res, _t;
        return (0, _regenerator2.default)().w(function (_context2) {
          while (1) switch (_context2.p = _context2.n) {
            case 0:
              _context2.p = 0;
              this.tableLoading = true;
              params = {
                appId: this.appId
              };
              _context2.n = 1;
              return (0, _dispositionl.listClassSetApi)(params);
            case 1:
              res = _context2.v;
              this.tableLoading = false;
              if (res.code === 0) {
                this.tableData = res.data;
                // const userData = []
                // res.data.forEach(element => {
                //   userData.push(element.name)
                // })
                // this.nameListData = userData
              }
              _context2.n = 3;
              break;
            case 2:
              _context2.p = 2;
              _t = _context2.v;
              console.log(_t);
            case 3:
              return _context2.a(2);
          }
        }, _callee2, this, [[0, 2]]);
      }));
      function listClassSetApi() {
        return _listClassSetApi2.apply(this, arguments);
      }
      return listClassSetApi;
    }(),
    // 添加
    saveClassSetApi: function () {
      var _saveClassSetApi2 = (0, _asyncToGenerator2.default)(/*#__PURE__*/(0, _regenerator2.default)().m(function _callee3() {
        var params, res, _t2;
        return (0, _regenerator2.default)().w(function (_context3) {
          while (1) switch (_context3.p = _context3.n) {
            case 0:
              _context3.p = 0;
              params = (0, _objectSpread2.default)({
                appId: this.appId
              }, this.ruleForm);
              if (this.ruleForm.upgradeModel === 2) {
                params.termList = [{
                  enable: 0,
                  // 0-禁用 1：启用
                  termItem: '邀请用户',
                  // 条件名称
                  timeRange: '30',
                  // 升级周期
                  requiredValue: '' // 条件值
                }, {
                  enable: 0,
                  // 0-禁用 1：启用
                  termItem: '自购订单',
                  // 条件名称
                  timeRange: '30',
                  // 升级周期
                  requiredValue: '' // 条件值
                }, {
                  enable: 0,
                  // 0-禁用 1：启用
                  termItem: '自购收货',
                  // 条件名称
                  timeRange: '30',
                  // 升级周期
                  requiredValue: '' // 条件值
                }, {
                  enable: 0,
                  // 0-禁用 1：启用
                  termItem: '预估收益',
                  // 条件名称
                  timeRange: '30',
                  // 升级周期
                  requiredValue: '' // 条件值
                }, {
                  enable: 0,
                  // 0-禁用 1：启用
                  termItem: '结算收益',
                  // 条件名称
                  timeRange: '30',
                  // 升级周期
                  requiredValue: '' // 条件值
                }];
              }
              _context3.n = 1;
              return (0, _dispositionl.saveClassSetApi)(params);
            case 1:
              res = _context3.v;
              if (res.code === 0) {
                this.close();
                this.listClassSetApi();
                this.$notify.success({
                  title: '温馨提示',
                  message: '添加成功'
                });
              }
              _context3.n = 3;
              break;
            case 2:
              _context3.p = 2;
              _t2 = _context3.v;
              console.log(_t2);
            case 3:
              return _context3.a(2);
          }
        }, _callee3, this, [[0, 2]]);
      }));
      function saveClassSetApi() {
        return _saveClassSetApi2.apply(this, arguments);
      }
      return saveClassSetApi;
    }(),
    // 删除
    deleteClassSetApi: function () {
      var _deleteClassSetApi2 = (0, _asyncToGenerator2.default)(/*#__PURE__*/(0, _regenerator2.default)().m(function _callee4(grade) {
        var params, res, _t3;
        return (0, _regenerator2.default)().w(function (_context4) {
          while (1) switch (_context4.p = _context4.n) {
            case 0:
              _context4.p = 0;
              params = {
                // userId: 0,
                appId: this.appId,
                grade: grade
              };
              _context4.n = 1;
              return (0, _dispositionl.deleteClassSetApi)(params);
            case 1:
              res = _context4.v;
              if (res.code === 0) {
                this.listClassSetApi();
                this.$notify.success({
                  title: '温馨提示',
                  message: '删除成功'
                });
              }
              _context4.n = 3;
              break;
            case 2:
              _context4.p = 2;
              _t3 = _context4.v;
              console.log(_t3);
            case 3:
              return _context4.a(2);
          }
        }, _callee4, this, [[0, 2]]);
      }));
      function deleteClassSetApi(_x2) {
        return _deleteClassSetApi2.apply(this, arguments);
      }
      return deleteClassSetApi;
    }(),
    // 详情
    getClassSetApi: function () {
      var _getClassSetApi2 = (0, _asyncToGenerator2.default)(/*#__PURE__*/(0, _regenerator2.default)().m(function _callee5(grade) {
        var _this4 = this;
        var params, res, _t4;
        return (0, _regenerator2.default)().w(function (_context5) {
          while (1) switch (_context5.p = _context5.n) {
            case 0:
              _context5.p = 0;
              params = {
                appId: this.appId,
                grade: grade
              };
              _context5.n = 1;
              return (0, _dispositionl.getClassSetApi)(params);
            case 1:
              res = _context5.v;
              if (res.code === 0) {
                this.ruleForm = res.data;
                console.log('字段', (0, _typeof2.default)(res.data.selfRate));
                res.data.termList.forEach(function (element) {
                  if (element.termItem === '邀请用户') {
                    _this4.ruleForm.termList[0] = element;
                  } else if (element.termItem === '自购订单') {
                    _this4.ruleForm.termList[1] = element;
                  } else if (element.termItem === '自购收货') {
                    _this4.ruleForm.termList[2] = element;
                  } else if (element.termItem === '预估收益') {
                    _this4.ruleForm.termList[3] = element;
                  } else if (element.termItem === '结算收益') {
                    _this4.ruleForm.termList[4] = element;
                  }
                });
              }
              _context5.n = 3;
              break;
            case 2:
              _context5.p = 2;
              _t4 = _context5.v;
              console.log(_t4);
            case 3:
              return _context5.a(2);
          }
        }, _callee5, this, [[0, 2]]);
      }));
      function getClassSetApi(_x3) {
        return _getClassSetApi2.apply(this, arguments);
      }
      return getClassSetApi;
    }(),
    // 更新
    updateClassSetApi: function () {
      var _updateClassSetApi2 = (0, _asyncToGenerator2.default)(/*#__PURE__*/(0, _regenerator2.default)().m(function _callee6() {
        var params, res, _t5;
        return (0, _regenerator2.default)().w(function (_context6) {
          while (1) switch (_context6.p = _context6.n) {
            case 0:
              _context6.p = 0;
              params = (0, _objectSpread2.default)({
                appId: this.appId
              }, this.ruleForm);
              if (this.ruleForm.upgradeModel === 2) {
                params.termList = [{
                  enable: 0,
                  // 0-禁用 1：启用
                  termItem: '邀请用户',
                  // 条件名称
                  timeRange: '30',
                  // 升级周期
                  requiredValue: '' // 条件值
                }, {
                  enable: 0,
                  // 0-禁用 1：启用
                  termItem: '自购订单',
                  // 条件名称
                  timeRange: '30',
                  // 升级周期
                  requiredValue: '' // 条件值
                }, {
                  enable: 0,
                  // 0-禁用 1：启用
                  termItem: '自购收货',
                  // 条件名称
                  timeRange: '30',
                  // 升级周期
                  requiredValue: '' // 条件值
                }, {
                  enable: 0,
                  // 0-禁用 1：启用
                  termItem: '预估收益',
                  // 条件名称
                  timeRange: '30',
                  // 升级周期
                  requiredValue: '' // 条件值
                }, {
                  enable: 0,
                  // 0-禁用 1：启用
                  termItem: '结算收益',
                  // 条件名称
                  timeRange: '30',
                  // 升级周期
                  requiredValue: '' // 条件值
                }];
              }
              _context6.n = 1;
              return (0, _dispositionl.updateClassSetApi)(params);
            case 1:
              res = _context6.v;
              if (res.code === 0) {
                this.close();
                this.listClassSetApi();
                this.$notify.success({
                  title: '温馨提示',
                  message: '编辑成功'
                });
              }
              _context6.n = 3;
              break;
            case 2:
              _context6.p = 2;
              _t5 = _context6.v;
              console.log(_t5);
            case 3:
              return _context6.a(2);
          }
        }, _callee6, this, [[0, 2]]);
      }));
      function updateClassSetApi() {
        return _updateClassSetApi2.apply(this, arguments);
      }
      return updateClassSetApi;
    }(),
    // 拖拽
    moveClassSetApi: function () {
      var _moveClassSetApi2 = (0, _asyncToGenerator2.default)(/*#__PURE__*/(0, _regenerator2.default)().m(function _callee7(grade, targetGrade) {
        var params, res, _t6;
        return (0, _regenerator2.default)().w(function (_context7) {
          while (1) switch (_context7.p = _context7.n) {
            case 0:
              _context7.p = 0;
              params = {
                appId: this.appId,
                grade: grade,
                targetGrade: Number(targetGrade + 1)
              };
              _context7.n = 1;
              return (0, _dispositionl.moveClassSetApi)(params);
            case 1:
              res = _context7.v;
              if (res.code === 0) {
                this.listClassSetApi();
                this.$notify.success({
                  title: '温馨提示',
                  message: '操作成功'
                });
              }
              _context7.n = 3;
              break;
            case 2:
              _context7.p = 2;
              _t6 = _context7.v;
              console.log(_t6);
            case 3:
              return _context7.a(2);
          }
        }, _callee7, this, [[0, 2]]);
      }));
      function moveClassSetApi(_x4, _x5) {
        return _moveClassSetApi2.apply(this, arguments);
      }
      return moveClassSetApi;
    }()
  }
};